/** What a composer keeps once a send succeeds: what was typed after the send, when the
 * box still starts with exactly what it held at the send (``atSend``); otherwise all of
 * it, as the operator has edited the sent text since. The box stays editable while a
 * message sends and the agent works, so a note written meanwhile survives. */
export const leftAfterSend = (current: string, atSend: string): string =>
  current.startsWith(atSend) ? current.slice(atSend.length).trimStart() : current;
